import { render } from "./breadCrubm.vue?vue&type=template&id=d89c2436&scoped=true"
import script from "./breadCrubm.vue?vue&type=script&lang=js"
export * from "./breadCrubm.vue?vue&type=script&lang=js"

import "./breadCrubm.vue?vue&type=style&index=0&id=d89c2436&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89c2436"]])

export default __exports__